import { Text } from '@pletly/ui';

export interface FileNameProps {
	name: string;
	variant?: 'default' | 'medium' | 'small';
}

const variantToCategoryMap = {
	default: 's2',
	medium: 'p2',
	small: 'c2',
};

export const FileName = ({ name, variant = 'default' }: FileNameProps) => {
	return (
		<Text category={variantToCategoryMap[variant]} numberOfLines={1}>
			{name}
		</Text>
	);
};
